import '@threatadvisor/react-utils/src/i18n';
import { NetworkClientProvider } from '@threatadvisor/react-utils/src/network-components';
import { RootErrorBoundary } from '@threatadvisor/react-utils/src/sentry';
import React, { ReactElement, ReactNode, Suspense } from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { BrowserRouter } from 'react-router-dom';
//import { ThemeProvider, ThreatAdvisorOidcProvider } from '@threatadvisor/react-components';
import { OidcSecure } from '@axa-fr/react-oidc';
import { BreadCrumbContextProvider } from './Menu/BreadCrumbContext';
import { ThemeProvider } from './ThemeProvider';
import { ThreatAdvisorOidcProvider } from './oidc';
import { UserProviderContext } from './oidc/UserProvider';

export function ThreatAdvisorRootProvider({
  children,
  basename,
  oidc_authority,
  oidc_client_id,
  oidc_scopes,
  disableServiceWorker
}: {
  children: ReactNode;
  basename: string;
  oidc_authority: string;
  oidc_client_id: string;
  oidc_scopes?: string;
  disableServiceWorker?: boolean;
}): ReactElement {
  // We use the Root Error Boundary twice
  // Top Level for error reporting on Network Client Provider
  // Under Suspence

  return (
    <RootErrorBoundary>
      <ThreatAdvisorOidcProvider
        authority={oidc_authority}
        oidcClientId={oidc_client_id}
        additionalScopes={oidc_scopes}
        disableServiceWorker={disableServiceWorker}
      >
        <DndProvider backend={HTML5Backend}>
          <ThemeProvider basename={basename}>
            <Suspense fallback={null}>
              <OidcSecure configurationName="config_show_access_token">
                <NetworkClientProvider>
                  <BrowserRouter basename="/">
                    <UserProviderContext>
                      <BreadCrumbContextProvider>{children}</BreadCrumbContextProvider>
                    </UserProviderContext>
                  </BrowserRouter>
                </NetworkClientProvider>
              </OidcSecure>
            </Suspense>
          </ThemeProvider>
        </DndProvider>
      </ThreatAdvisorOidcProvider>
    </RootErrorBoundary>
  );
}
